<template>
    <b-container class="sign-content-container">
        <b-row>
            <b-col><h1>Wähle zwischen Portait- und Actionbild</h1></b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>
                    Wir haben die folgenden Bilder von Dir gefunden. Bitte wähle hier aus, ob Du ein Produkt (Tasse, Poster, Alu-Dibond) mit dem Portraitbild oder dem Actionbild bestellen möchtest.
                </p>
                <p>
                    Hinweis: Bitte beachte, dass bei den angezeigten Bildern nur eine Vorschau angezeigt wird auf dieser noch KEINE Bildbearbeitung erfolgt ist. Unsere Grafiker werden die gewünschten Bilder erst nach dem Bestelleingang bearbeiten.
                </p>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col class="image-type-container">
                <p><b>Dein Portraitbild</b></p>
                <b-img :src="baseUrl + user.portraitUrl" fluid class="mb-3"/>
                <b-button :class="selectedType === 'PORTRAIT' ? 'sf-primary-button': 'sf-primary-button-outline'" @click="setType('PORTRAIT')">
                    <template v-if="selectedType === 'PORTRAIT'">
                        Ausgewählt
                    </template>
                    <template v-else>
                        Auswählen
                    </template>
                </b-button>
            </b-col>
            <b-col class="image-type-container">
                <p><b>Dein Actionbild</b></p>
                <b-img :src="baseUrl + user.actionUrl" fluid class="mb-3"/>
                <b-button :class="selectedType === 'ACTION' ? 'sf-primary-button': 'sf-primary-button-outline'" @click="setType('ACTION')">
                    <template v-if="selectedType === 'ACTION'">
                        Ausgewählt
                    </template>
                    <template v-else>
                        Auswählen
                    </template>
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="align-left"><b-button class="sf-secondary-button form-margin" @click="back">Zurück</b-button></b-col>
            <b-col class="align-right">
                <b-button class="sf-primary-button form-margin" :class="selectedType ? 'sf-primary-button': ['sf-primary-button-outline', 'disabled']" @click="next">
                    Weiter
                </b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "SignStep2",
        data: () => ({
            selectedType: '',
            baseUrl: 'https://tsvploen-bestellung.stickerfive.de'
        }),
        props: {
            user: {
                required: true
            }
        },
        methods: {
            next() {
                if(this.selectedType)
                    this.$emit('next', {type: this.selectedType})
            },
            setType(type) {
                this.selectedType = type
            },
            back() {
                this.$emit('back')
            },
        },
        mounted() {
            this.selectedType = this.user.type
        }
    }
</script>

<style scoped lang="scss">

</style>
